var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          key: 1,
          ref: "registerForm",
          staticClass: "ec-register-form switch-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            hideRequiredMark: "",
            colon: false,
            labelAlign: "left",
          },
        },
        [
          _vm.comp === "backEmail"
            ? [
                _c(
                  "a-form-model-item",
                  {
                    key: _vm.comp + "email",
                    attrs: {
                      prop: "email",
                      label: _vm.$t("common_form_email"),
                      htmlFor: "email",
                    },
                  },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "forlogin",
                          rawName: "v-forlogin",
                          value: "email",
                          expression: "'email'",
                        },
                      ],
                      attrs: { autoComplete: "off" },
                      model: {
                        value: _vm.form.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "a-form-model-item",
                  {
                    key: _vm.comp + "messageCode",
                    attrs: {
                      prop: "messageCode",
                      label: _vm.$t("common_form_email_code"),
                      htmlFor: "messageCode",
                    },
                  },
                  [
                    _c(
                      "a-input",
                      {
                        directives: [
                          {
                            name: "forlogin",
                            rawName: "v-forlogin",
                            value: "messageCode",
                            expression: "'messageCode'",
                          },
                        ],
                        attrs: { maxLength: 6, autoComplete: "off" },
                        model: {
                          value: _vm.form.messageCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "messageCode", $$v)
                          },
                          expression: "form.messageCode",
                        },
                      },
                      [
                        _c(
                          "a-spin",
                          {
                            attrs: {
                              slot: "suffix",
                              spinning: _vm.isCodeLoading && !_vm.timing,
                            },
                            slot: "suffix",
                          },
                          [
                            _c(
                              "a-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.timing,
                                    expression: "!timing",
                                  },
                                ],
                                attrs: { id: "captcha-button", type: "link" },
                              },
                              [_vm._v(_vm._s(_vm.$t("common_btn_send_ver")))]
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.timing,
                                    expression: "timing",
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(_vm.timing) + " s")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "a-form-model-item",
                  {
                    key: _vm.comp + "phone",
                    staticClass: "input-addon-before-form-item",
                    attrs: {
                      prop: "phone",
                      label: _vm.$t("common_form_phone"),
                      htmlFor: "phone",
                    },
                  },
                  [
                    _c(
                      "a-input",
                      {
                        directives: [
                          {
                            name: "forlogin",
                            rawName: "v-forlogin",
                            value: "phone",
                            expression: "'phone'",
                          },
                        ],
                        attrs: { autoComplete: "off", maxLength: 11 },
                        on: {
                          keyup: function ($event) {
                            _vm.form.phone = _vm.form.phone.replace(
                              /[^\d]/g,
                              ""
                            )
                          },
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      },
                      [
                        _c(
                          "a-select",
                          {
                            attrs: {
                              slot: "addonBefore",
                              value: _vm._f("disCountryCode")(
                                _vm.form.phoneCode
                              ),
                              dropdownMatchSelectWidth: false,
                              getPopupContainer: () =>
                                _vm.$refs["registerForm"].$el,
                            },
                            slot: "addonBefore",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  overflow: "auto",
                                  padding: "4px 0",
                                },
                                style: {
                                  minWidth:
                                    _vm.currentLang === "zh_CN"
                                      ? "260px"
                                      : "400px",
                                },
                                attrs: { slot: "dropdownRender" },
                                slot: "dropdownRender",
                              },
                              [
                                _c("RecycleScroller", {
                                  staticStyle: {
                                    "max-height": "400px",
                                    "min-height": "32px",
                                    overflow: "auto",
                                  },
                                  attrs: {
                                    items: _vm.countryCodeList,
                                    "item-size": 32,
                                    buffer: 100,
                                    prop: {
                                      value: "index",
                                      text:
                                        "name" +
                                        _vm.currentLangList[_vm.currentLang],
                                    },
                                  },
                                  on: { selected: _vm.changeInternational },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function ({ item }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                width: "100%",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    width: "calc(100% - 70px)",
                                                    "white-space": "nowrap",
                                                    "text-overflow": "ellipsis",
                                                    overflow: "hidden",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item[
                                                        "name" +
                                                          _vm.currentLangList[
                                                            _vm.currentLang ===
                                                            "ko_KR"
                                                              ? "en_US"
                                                              : _vm.currentLang
                                                          ]
                                                      ]
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "2px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "+ " +
                                                      _vm._s(item.phonecode)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-form-model-item",
                  {
                    key: _vm.comp + "imgCode",
                    attrs: {
                      prop: "imgCode",
                      label: _vm.$t("common_form_identifying_code"),
                      htmlFor: "imgCode",
                    },
                  },
                  [
                    _c(
                      "a-input",
                      {
                        directives: [
                          {
                            name: "forlogin",
                            rawName: "v-forlogin",
                            value: "imgCode",
                            expression: "'imgCode'",
                          },
                        ],
                        attrs: { autoComplete: "off", maxLength: 4 },
                        model: {
                          value: _vm.form.imgCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "imgCode", $$v)
                          },
                          expression: "form.imgCode",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              width: "56px",
                              height: "33px",
                              background: "rgb(253, 253, 253)",
                            },
                            attrs: { slot: "suffix" },
                            slot: "suffix",
                          },
                          [
                            _vm.imgCodeLoading
                              ? _c("a-spin", {
                                  staticStyle: {
                                    "margin-left": "25px",
                                    "margin-top": "9px",
                                  },
                                  attrs: { size: "small" },
                                })
                              : _c("img", {
                                  staticStyle: {
                                    cursor: "pointer",
                                    width: "100%",
                                    height: "100%",
                                  },
                                  attrs: { src: _vm.imgCodeData },
                                  on: { click: _vm.getImgCode },
                                }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "a-form-model-item",
                  {
                    key: _vm.comp + "messageCode",
                    attrs: {
                      prop: "messageCode",
                      label: _vm.$t("common_form_sms_code"),
                      htmlFor: "messageCode",
                    },
                  },
                  [
                    _c(
                      "a-input",
                      {
                        directives: [
                          {
                            name: "forlogin",
                            rawName: "v-forlogin",
                            value: "messageCode",
                            expression: "'messageCode'",
                          },
                        ],
                        attrs: { maxLength: 6, autoComplete: "off" },
                        model: {
                          value: _vm.form.messageCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "messageCode", $$v)
                          },
                          expression: "form.messageCode",
                        },
                      },
                      [
                        _c(
                          "a-spin",
                          {
                            attrs: {
                              slot: "suffix",
                              spinning: _vm.isCodeLoading && !_vm.timing,
                            },
                            slot: "suffix",
                          },
                          [
                            _c(
                              "a-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.timing,
                                    expression: "!timing",
                                  },
                                ],
                                attrs: { id: "captcha-button", type: "link" },
                              },
                              [_vm._v(_vm._s(_vm.$t("common_btn_send_ver")))]
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.timing,
                                    expression: "timing",
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(_vm.timing) + " s")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
          _c(
            "a-form-model-item",
            {
              attrs: {
                prop: "password",
                label: _vm.$t("common_form_设置密码"),
                htmlFor: "password",
              },
            },
            [
              _c("a-input-password", {
                directives: [
                  {
                    name: "forlogin",
                    rawName: "v-forlogin",
                    value: "password",
                    expression: "'password'",
                  },
                ],
                attrs: { autoComplete: "new-password" },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            {
              attrs: {
                prop: "password2",
                label: _vm.$t("common_form_再次输入密码"),
                htmlFor: "password2",
              },
            },
            [
              _c("a-input-password", {
                directives: [
                  {
                    name: "forlogin",
                    rawName: "v-forlogin",
                    value: "password2",
                    expression: "'password2'",
                  },
                ],
                attrs: { autoComplete: "new-password" },
                model: {
                  value: _vm.form.password2,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password2", $$v)
                  },
                  expression: "form.password2",
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a",
        {
          staticClass: "ec-register-submit",
          class: { "ec-register-submit__loading": _vm.submitLoading },
        },
        [
          _vm.submitLoading
            ? _c(
                "a-spin",
                [
                  _c("a-icon", {
                    staticStyle: { "font-size": "24px", color: "#fff" },
                    attrs: { slot: "indicator", type: "loading", spin: "" },
                    slot: "indicator",
                  }),
                ],
                1
              )
            : _c(
                "span",
                {
                  staticStyle: { flex: "1", "text-align": "center" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("common_btn_confirm")))]
              ),
        ],
        1
      ),
      _c(
        "a",
        {
          staticClass: "ec-register-submit",
          staticStyle: {
            background: "#fff",
            color: "#007BFC",
            "font-size": "14px",
            "margin-top": "10px",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("to", "login")
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("common_login_return_login")) + " ")]
      ),
      _c("div", { attrs: { id: "captcha-element" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }